import ApplicationController from './application_controller'

export default class extends ApplicationController {
  async connect() {
    let firstError =
      document.querySelector('.is-invalid') || document.querySelector('.form-label.text-danger')
    if (firstError) {
      await this.sleep(10)
      firstError.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }
}
